// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e1621186","455":"e1ccf7a4","977":"cc32dd37"}[chunkId] + ".chunk.js";
};